import { c as _c } from "react/compiler-runtime";
import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CtaButton from 'components/essentials/Cta/CtaButton';
const FAQAccordionUI = t0 => {
  const $ = _c(23);
  const {
    title,
    content,
    isActive,
    toggleAccordion
  } = t0;
  const contentRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState("0px");
  let t1;
  let t2;
  if ($[0] !== isActive) {
    t1 = () => {
      if (isActive) {
        setMaxHeight(`${contentRef.current.scrollHeight}px`);
        setTimeout(() => {
          setMaxHeight("unset");
        }, 600);
      } else {
        setMaxHeight(`${contentRef.current.scrollHeight}px`);
        setTimeout(() => {
          setMaxHeight("0px");
        }, 100);
      }
    };
    t2 = [isActive];
    $[0] = isActive;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== title) {
    t3 = <span className="text-sm font-bold normal-case">{title}</span>;
    $[3] = title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = isActive ? "-" : "+";
  let t5;
  if ($[5] !== t4) {
    t5 = <span className="leading-[1.3125rem] transition-[transform_.6s_ease]">{t4}</span>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t5) {
    t6 = <div className="flex text-left justify-between w-full">{t3}{t5}</div>;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6 || $[11] !== toggleAccordion) {
    t7 = <CtaButton noLinkPadding={true} spacing="sm" hasArrow={false} styling="link" color="brand" className="cursor-pointer [&>span]:w-full" onClick={toggleAccordion} block={true} textClassName="w-full [&>span]:w-full">{t6}</CtaButton>;
    $[10] = t6;
    $[11] = toggleAccordion;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== maxHeight) {
    t8 = {
      maxHeight
    };
    $[13] = maxHeight;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== content) {
    t9 = <div className="text-sm mt-3 mx-0 mb-4">{content}</div>;
    $[15] = content;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t8 || $[18] !== t9) {
    t10 = <div className="text-sm text-gray overflow-hidden transition-[max-height_.6s_ease] [&_p]:text-sm [&_p]:mb-0" ref={contentRef} style={t8}>{t9}</div>;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t7) {
    t11 = <div className="flex flex-col items-start mb-4">{t7}{t10}</div>;
    $[20] = t10;
    $[21] = t7;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
};
FAQAccordionUI.propTypes = {
  title: PropTypes.string,
  content: PropTypes.node,
  isActive: PropTypes.bool,
  toggleAccordion: PropTypes.func
};
export default FAQAccordionUI;